import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  base: "/ocr/",
  routes: [

    /**
     * 通用文档识别
     */

    ,{
      path: '/',
      name: 'text1',
      component: () => import('../views/general_docs/general_text.vue'),
      meta: { en_name: "general_text" },
    },
    {
      path: '/v1_general',
      name: 'general_text',
      component: () => import('../views/general_docs/general_text.vue'),
      meta: { en_name: "general_text" },
    },
    {
      path: '/v1_table_api',
      name: 'table',
      component: () => import('../views/general_docs/general_table.vue'),
      meta: {
        en_name: "general_table"
      }
    },
    {
      path: '/v1_seal',
      name: 'seal',
      component: () => import('../views/general_docs/seal.vue'),
      meta: {
        en_name: "seal"
      }
    },
    {
      path: '/v1_financial_report',
      name: 'v1_financial_report',
      component: () => import('../views/general_docs/financial_report.vue'),
      meta: {
        en_name: "v1_financial_report"
      }
    },

    /**
     * 个人证件识别
     */
    {
      path: '/v1_id_card',
      name: 'id_card',
      component: () => import('../views/cards/id_card.vue'),
      meta: { en_name: "id_card" },
    },
    {
      path: '/v2_id_card_check',
      name: 'id_card_quality',
      component: () => import('../views/cards/id_card_quality.vue'),
      meta: { en_name: "id_card_quality" },
    },
    {
      path: '/v2_id_card',
      name: 'id_card_with_quality',
      component: () => import('../views/cards/id_card_with_quality.vue'),
      meta: { en_name: "id_card_with_quality" },
    },
    {
      path: '/v1_bank_card',
      name: 'bank_card',
      component: () => import('../views/cards/bank_card.vue'),
      meta: { en_name: "bank_card" },
    },
    {
      path: '/v1_certify_invoice',
      name: 'certify_invoice',
      component: () => import('../views/cards/certify_invoice.vue'),
      meta: { en_name: "certify_invoice" },
    },
    {
      path: '/v1_temp_id',
      name: 'temp_id_card',
      component: () => import('../views/cards/temp_id_card.vue'),
      meta: { en_name: "temp_id_card" },
    },
    {
      path: '/v1_marriage_proof',
      name: 'marry_card',
      component: () => import('../views/cards/marry_card.vue'),
      meta: { en_name: "marry_card" },
    },
    {
      path: '/v1_passport',
      name: 'passport_card',
      component: () => import('../views/cards/passport_card.vue'),
      meta: { en_name: "passport_card" },
    },
    {
      path: '/v1_birth_cert',
      name: 'birth_card',
      component: () => import('../views/cards/birth_card.vue'),
      meta: { en_name: "birth_card" },
    },
    {
      path: '/v1_hukou_proof',
      name: 'house',
      component: () => import('../views/cards/house.vue'),
      meta: { en_name: "house" },
    },
    {
      path: '/v1_junguanzheng',
      name: 'official_card',
      component: () => import('../views/cards/official_card.vue'),
      meta: { en_name: "official_card" },
    },
    {
      path: '/v1_business_card',
      name: 'business_card',
      component: () => import('../views/cards/business_card.vue'),
      meta: { en_name: "business_card" },
    },
    {
      path: '/v1_macau_id_card',
      name: 'macao_id_card',
      component: () => import('../views/cards/macao_id_card.vue'),
      meta: { en_name: "macao_id_card" },
    },
    {
      path: '/v1_hk_id',
      name: 'hk_id_card',
      component: () => import('../views/cards/hk_id_card.vue'),
      meta: { en_name: "hk_id_card" },
    },
    {
      path: '/v1_foreigner_greencard',
      name: 'foreigner',
      component: () => import('../views/cards/foreigner.vue'),
      meta: { en_name: "foreigner" },
    },
    {
      path: '/v1_gat_jzz',
      name: 'hmt_card',
      component: () => import('../views/cards/hmt_card.vue'),
      meta: { en_name: "hmt_card" },
    },
    {
      path: '/v1_ga_pass',
      name: 'hm_pass_card',
      component: () => import('../views/cards/hm_pass_card.vue'),
      meta: { en_name: "hm_pass_card" },
    },
    {
      path: '/v1_gat_pass',
      name: 'hmt_pass_card',
      component: () => import('../views/cards/hmt_pass_card.vue'),
      meta: { en_name: "hmt_pass_card" },
    },

    /**
     * 车辆相关
     */
    {
      path: '/v1_vehicle_license',
      name: 'vehicleLicense',
      component: () => import('../views/car/vehicleLicense.vue'),
      meta: { en_name: "vehicleLicense" },
    },
    {
      path: '/v1_driver_license',
      name: 'driverLicense',
      component: () => import('../views/car/driverLicense.vue'),
      meta: { en_name: "driverLicense" },
    },
    {
      path: '/v1_vehicle_register',
      name: 'vehicleRegistration',
      component: () => import('../views/car/vehicleRegistration.vue'),
      meta: { en_name: "vehicleRegistration" },
    },
    {
      path: '/v1_vehicle_cert',
      name: 'vehicleCertificate',
      component: () => import('../views/car/vehicleCertificate.vue'),
      meta: { en_name: "vehicleCertificate" },
    },
    {
      path: '/v1_lpr',
      name: 'licensePlate',
      component: () => import('../views/car/licensePlate.vue'),
      meta: { en_name: "licensePlate" },
    },
    {
      path: '/v1_vehicle_invoice',
      name: 'newCarInvoice',
      component: () => import('../views/car/newCarInvoice.vue'),
      meta: { en_name: "newCarInvoice" },
    },
    {
      path: '/v1_vehicle_invoice2',
      name: 'usedCarInvoices',
      component: () => import('../views/car/usedCarInvoices.vue'),
      meta: { en_name: "usedCarInvoices" },
    },
    {
      path: '/v1_e_policy',
      name: 'policy',
      component: () => import('../views/car/policy.vue'),
      meta: { en_name: "policy" },
    },
    {
      path: '/v1_vin',
      name: 'VIN_code',
      component: () => import('../views/car/VIN_code.vue'),
      meta: { en_name: "VIN_code" },
    },

    /**
     * 财务票据识别
     */
    {
      path: '/v2_fapiao',
      name: 'financialMixed',
      component: () => import('../views/invoice/financialMixed.vue'),
      meta: { en_name: "financialMixed" },
    },
    {
      path: '/v1_invoice',
      name: 'VAT',
      component: () => import('../views/invoice/VAT.vue'),
      meta: { en_name: "VAT" },
    },
  
    /**
     * 机构文档
     */
    {
      path: '/v1_business_license',
      name: 'businessLicense',
      component: () => import('../views/institutional/businessLicense.vue'),
      meta: { en_name: "businessLicense" },
    },
    {
      path: '/v1_bank_khxkz',
      name: 'openingPermit',
      component: () => import('../views/institutional/openingPermit.vue'),
      meta: { en_name: "openingPermit" },
    },
    {
      path: '/v1_realestate_cert',
      name: 'deed',
      component: () => import('../views/institutional/deed.vue'),
      meta: { en_name: "deed" },
    },
    {
      path: '/v1_realestate_register',
      name: 'realEstate',
      component: () => import('../views/institutional/realEstate.vue'),
      meta: { en_name: "realEstate" },
    },
    {
      path: '/v1_realestate_proof',
      name: 'realEstateCertificate',
      component: () => import('../views/institutional/realEstateCertificate.vue'),
      meta: { en_name: "realEstateCertificate" },
    },
    {
      path: '/v1_check_book',
      name: 'bankCheck',
      component: () => import('../views/institutional/bankCheck.vue'),
      meta: { en_name: "bankCheck" },
    },
    {
      path: '/v1_bank_cdhp',
      name: 'bankAcceptanceBill',
      component: () => import('../views/institutional/bankAcceptanceBill.vue'),
      meta: { en_name: "bankAcceptanceBill" },
    },
    {
      path: '/v1_medicine_list',
      name: 'drugList',
      component: () => import('../views/institutional/drugList.vue'),
      meta: { en_name: "drugList" },
    },
    {
      path: '/v1_custom_form',
      name: 'customForm',
      component: () => import('../views/institutional/customForm.vue'),
      meta: { en_name: "customForm" },
    },
    {
      path: '/v1_bank_statement',
      name: 'bankStatement',
      component: () => import('../views/institutional/bankStatement.vue'),
      meta: { en_name: "bankStatement" },
    },

    /**
     * 人脸检测识别
     */
    {
      path: '/v1_compare',
      name: 'faceComparison',
      component: () => import('../views/face/faceComparison.vue'),
      meta: { en_name: "faceComparison" },
    },
    {
      path: '/v1_detect',
      name: 'faceDetection',
      component: () => import('../views/face/faceDetection.vue'),
      meta: { en_name: "faceDetection" },
    },
    {
      path: '/v1_verify_bank_card',
      name: 'bankCardDetection',
      component: () => import('../views/face/bankCardDetection.vue'),
      meta: { en_name: "bankCardDetection" },
    },
    {
      path: '/v1_verify_invoice',
      name: 'invoiceVerify',
      component: () => import('../views/face/invoiceVerify.vue'),
      meta: { en_name: "invoiceVerify" },
    },
    {
      path: '/v1_verify_id',
      name: 'verifyId',
      component: () => import('../views/face/verifyId.vue'),
      meta: { en_name: "verifyId" },
    },
    {
      path: '/v3_liveness',
      name: 'v3_liveness',
      component: () => import('../views/face/v3_liveness.vue'),
      meta: { en_name: "v3_liveness" },
    },
    {
      path: '/v3_actionlive',
      name: 'motionLiveness',
      component: () => import('../views/face/motionLiveDetection.vue'),
      meta: { en_name: "motionLiveness" },
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js